import qs from 'qs';
import request from '@/config/request';

/*
  模板列表
  accessKeyId,smsSecret,smsSignName,templateCode,variableParam
*/
export function getSmsConfigList({ page, pageSize, ...rest }) {
  return request({
    url: '/sms/getSmsConfigList',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  添加模板
  accessKeyId, smsSecret,smsSignName,templateCode,variableParam
*/
export function addSmsConfig(rest) {
  return request({
    url: '/sms/addSmsConfig',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  删除模板
  id
*/
export function deleteSmsConfig(id) {
  return request({
    url: '/sms/deleteSmsConfig',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  发送模板消息
  id，phones，smsParams
*/
export function sendMsg(rest) {
  return request({
    url: '/sms/sendMsg',
    method: 'post',
    data: { smsParams: rest },
  });
}

/*
  获取会员列表
  userPhone
*/
export function getShopUserList(userPhone) {
  return request({
    url: '/smallTicket/getShopUserList',
    method: 'post',
    data: qs.stringify({ userPhone }),
  });
}

/*
  获取模板详情
  id
*/
export function getSmsConfig(id) {
  return request({
    url: '/sms/getSmsConfig',
    method: 'post',
    data: qs.stringify({ id }),
  });
}
// 短信发送记录
export function getAdminShortMessageList(data) {
  return request({
    url: '/shortMessage/getAdminShortMessageList',
    method: 'post',
    data: qs.stringify(data),
  });
}
